import { type FC, type ReactNode, useMemo, useState } from "react";

import { API } from "../api/util";

import { ApisContext } from "./ApisContext";

export const ApisContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [step, setStep] = useState(API);
    const [agreement, setAgreement] = useState(false);

    const value: ApisContext = useMemo(
        () => ({
            step,
            setStep,
            agreement,
            setAgreement,
        }),
        [agreement, step],
    );

    return <ApisContext.Provider value={value}>{children}</ApisContext.Provider>;
};
